import { render, staticRenderFns } from "./QuickRegister.vue?vue&type=template&id=282214a7&scoped=true"
import script from "./QuickRegister.vue?vue&type=script&lang=js"
export * from "./QuickRegister.vue?vue&type=script&lang=js"
import style0 from "./QuickRegister.vue?vue&type=style&index=0&id=282214a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282214a7",
  null
  
)

export default component.exports